import { render, staticRenderFns } from "./GlobalExplainer.vue?vue&type=template&id=eb8761a6&scoped=true"
import script from "./GlobalExplainer.vue?vue&type=script&lang=ts"
export * from "./GlobalExplainer.vue?vue&type=script&lang=ts"
import style0 from "./GlobalExplainer.vue?vue&type=style&index=0&id=eb8761a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8761a6",
  null
  
)

export default component.exports